<template lang="pug">
  
  div
    MHeader( page-title="Access Control" )
    div( v-if="$apollo.loading" ) Loading...
    div( class="ibox" v-else )
      div( class="ibox-content" )
        p For each section, enter a new-line-separated list of emails and/or company names (case insensitive) to grant access.

        
        p
          label API
          textarea( class="form-control" rows="10" v-on:change="update($event, 'api')" )
            | {{ accessControl.api.join('\n') }}
        
        p
          label Advertiser Management
          textarea( class="form-control" rows="10" v-on:change="update($event, 'advertiserManagement')" )
            | {{ accessControl.advertiserManagement.join('\n') }}
        
        p
          label Error codes instead of flashes
          textarea( class="form-control" rows="10" v-on:change="update($event, 'flashes')" )
            | {{ accessControl.flashes.join('\n') }}

        p
          label Advertiser Certification
          textarea( class="form-control" rows="10" v-on:change="update($event, 'advertiserCertification')" )
            | {{ accessControl.advertiserCertification.join('\n') }}

        p
          label Geek Features
          br
          small Batch ID, Status and Link Owner on Output Report, Assign and Notify, Tracking Metadata.
          textarea( class="form-control" rows="10" v-on:change="update($event, 'geekFeatures')" )
            | {{ accessControl.geekFeatures.join('\n') }}
        
        p
          label Custom master tag submission
          textarea( class="form-control" rows="10" v-on:change="update($event, 'customMasterTagSubmission')" )
            | {{ accessControl.customMasterTagSubmission.join('\n') }}
        p
          label Whitelisting
          textarea( class="form-control" rows="10" v-on:change="update($event, 'whitelisting')" )
            | {{ accessControl.whitelisting.join('\n') }}
        
        p
          label Tech publisher submission
          textarea( class="form-control" rows="10" v-on:change="update($event, 'techPublisherSubmission')" )
            | {{ accessControl.techPublisherSubmission.join('\n') }}
        p
          label  Multi submission
          textarea( class="form-control" rows="10" v-on:change="update($event, 'multiSubmission')" )
            | {{ accessControl.multiSubmission.join('\n') }}
        p
          label  Consent submission
          textarea( class="form-control" rows="10" v-on:change="update($event, 'consentSubmission')" )
            | {{ accessControl.consentSubmission.join('\n') }}
        
        p
          label Exclude From Moonpull Lite Audit Auto-Submission
          textarea( class="form-control" rows="10" v-on:change="update($event, 'moonpullLiteSubmission')" )
            | {{ accessControl.moonpullLiteSubmission.join('\n') }}
        p
          label Enterprise Reporting Access
          textarea(class="form-control" rows="10" v-on:change="update($event, 'enterpriseReportAccess')")
            | {{ accessControl.enterpriseReportAccess.join('\n') }}
        
        p
          label Convert-a-link submission
          textarea(class="form-control" rows="10" v-on:change="update($event, 'convertalinkSubmission')")
            | {{ accessControl.convertalinkSubmission.join('\n') }}
        p
          label Moonpull Lite report
          textarea(class="form-control" rows="10" v-on:change="update($event, 'moonpullLiteReport')")
            | {{ accessControl.moonpullLiteReport.join('\n') }}
        p
          label Moonpull Lite Custom Variables
          textarea(class="form-control" rows="10" v-on:change="update($event, 'moonpullLiteReportCustomVariables')")
            | {{ accessControl.moonpullLiteReportCustomVariables.join('\n') }}
        p
          label App Association Badges
          textarea(class="form-control" rows="10" v-on:change="update($event, 'appAssociations')")
            | {{ accessControl.appAssociations.join('\n') }}
        p 
          label Scheduler Monthly option
          textarea(class="form-control" rows="10" v-on:change="update($event, 'monthlyScheduling')")
            | {{ accessControl.monthlyScheduling.join('\n') }}
        p 
          label CMP Counts
          textarea(class="form-control" rows="10" v-on:change="update($event, 'cmpCounts')")
            | {{ accessControl.cmpCounts.join('\n') }}

        p
          label Exclude Enterprise Reporting
          textarea( class="form-control" rows="10" v-on:change="update($event, 'enterpriseReporting')" )
            | {{ accessControl.enterpriseReporting.join('\n') }}
        
        p
          label Exclude Scheduling
          textarea( class="form-control" rows="10" v-on:change="update($event, 'scheduling')" )
            | {{ accessControl.scheduling.join('\n') }}
        
        hr
        h2 Inactive access controls
        p
          label Moonpull Verification ( Inactive )
          textarea( class="form-control" rows="10" v-on:change="update($event, 'moonpullVerification')" )
            | {{ accessControl.moonpullVerification.join('\n') }}
        
        
        p( class="text-right" )
          button( class="btn btn-primary" v-on:click="save" v-bind:disabled="saving" )
            span( v-if="saving" ) Saving...
            span( v-else ) Save

</template>

<style lang="scss" scoped>

</style>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({
  
  data() {
    return {
      saving: false,
    }
  },

  apollo: {
    accessControl: {
      query: gql`query PlatformContentByKey($key: String!) {
        platformContentByKey(key: $key)
      }`,
      variables: {
        key: 'accessControl',
      },
      update(data) {
        try {
          const parsed = JSON.parse(data.platformContentByKey)
          return parsed || {}
        } catch (e) {
          return []
        }
      }
    }
  },

  methods: {

    update(e, key) {
      this.accessControl[key] = e.target.value.split('\n')
    },

    async save() {
      this.saving = true
      await this.$apollo.mutate({
        mutation: gql`mutation UpdatePlatformContentByKey($key: String!, $value: String!) {
          updatePlatformContentByKey(key: $key, value: $value)
        }`,
        variables: {
          key: 'accessControl',
          value: JSON.stringify(this.accessControl),
        }
      })
      this.saving = false
    },

  }

})
</script>